import { cn } from "@/lib/utils";

interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
}

/**
 * O indicador de espera.
 *
 * Um arco fino em vez de um anel grosso: a 2px de espessura o círculo lê-se
 * como um objecto pesado a girar; a 1.5px lê-se como um traço. O resto do anel
 * fica quase invisível — o que se vê é o arco a rodar, não a moldura.
 */
export function LoadingSpinner({ size = "md", className }: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: "w-4 h-4 border-[1.5px]",
    md: "w-5 h-5 border-[1.5px]",
    lg: "w-6 h-6 border-2",
    xl: "w-8 h-8 border-2",
  };

  return (
    <div
      className={cn(
        "animate-spin rounded-full border-foreground/8 border-t-primary",
        sizeClasses[size],
        className
      )}
      role="status"
      aria-label="A carregar"
    >
      <span className="sr-only">A carregar…</span>
    </div>
  );
}
